import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import type {GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field} from 'nutshell-graphql-types';

import type {FormFieldSchema} from '../../../core/nutshell-fields/types';

import {ActivateFormModalContent} from './activate-form-modal-content';

type Props = {
    fields: Field[];
    formSchema: FormFieldSchema;
    onActivateForm: () => Promise<any>;
    onClose: () => void;
};

export function ActivateFormModal(props: Props) {
    return (
        <Modal trapFocus={true} isOpen={true} onClose={props.onClose} maxHeight={680}>
            <ActivateFormModalContent
                fields={props.fields}
                onClose={props.onClose}
                onActivateForm={props.onActivateForm}
                formSchema={props.formSchema}
            />
        </Modal>
    );
}
